import React from "react";
import { X } from "lucide-react";
import { AlertProps } from "../../types";

const Alert: React.FC<AlertProps> = ({ alert, onClose }) => {
  if (!alert.show) return null;

  return (
    <div
      className={`mx-6 mt-4 p-4 rounded-lg flex items-center justify-between animate-in slide-in-from-top-2 duration-300 ${
        alert.type === "success"
          ? "bg-green-50 text-green-800 border border-green-200"
          : "bg-red-50 text-red-800 border border-red-200"
      }`}
    >
      <span className="font-medium">{alert.message}</span>
      <button
        onClick={onClose}
        className="ml-4 text-gray-500 hover:text-gray-700 transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default Alert;
